import { TableCell, TableRow } from '@material-ui/core'
import React from 'react'

export const ColumnaSolPagoOP = () => {
  return (
    <TableRow>
      <TableCell align="left">Id Solicitud Pago</TableCell>
      <TableCell align="left">Sol Pag Anterior</TableCell>
      <TableCell align="left">Id Solicitud</TableCell>
      <TableCell align="left">Apellido y Nombre</TableCell>
      <TableCell align="left">Cod nom</TableCell>
      <TableCell align="left">Descripcion</TableCell>
      <TableCell align="left">Cantidad</TableCell>
      <TableCell align="left">Diagnostico</TableCell>
      <TableCell align="left">Razon Social</TableCell>
      <TableCell align="left">Letra</TableCell>
      <TableCell align="left">Nro Comprob</TableCell>
      <TableCell align="left">Fecha Comp</TableCell>
      <TableCell align="left">Imp Fact</TableCell>
      <TableCell align="left">Orden de Pago</TableCell>
      <TableCell align="left">Imagenes</TableCell>
    </TableRow>

  )
}
